// TODO We need to refactor all code with "navigateTo" usage
// We should remove window.history and window.location usage.
// Jest tests does not work with window.history and window.location
// because React Router "MemoryRouter" is used.
export const navigateTo = (pathname: string, state: Record<string, any> = {}) => {
  window.history.pushState(state, '', pathname);
  window.dispatchEvent(new Event('popstate'));
};
